export default function playerGlobalStateManager() {
  let instance = null;

  function saveFlagToLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  function loadFlagFromLocalStorage(key) {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : false;
  }

  function createInstance() {
    const trueMaxHealth = 8;
    let currentMaxHealth = 1;
    let health = 1;

    let hasKey = false;
    let hasSword = false;
    let hasGivenSwordToNaoko = false;
    let hasStrawberries = false;
    let hasGivenStrawberriesToSatoshi = false;
    let hasManga = false;
    let hasGivenMangaToMari = false;
    let hasOriyoki = false;
    let hasGivenOriyokiToKoji = false;

    return {
      // Health
      getTrueMaxHealth: () => trueMaxHealth,
      setCurrentMaxHealth(value) {
        currentMaxHealth = Math.min(value, trueMaxHealth);
        if (health > currentMaxHealth) health = currentMaxHealth;
      },
      getCurrentMaxHealth: () => currentMaxHealth,
      setHealth(value) {
        health = Math.max(0, Math.min(value, currentMaxHealth));
      },
      getHealth: () => health,

      // Flags
      setHasKey(value) {
        hasKey = value;
      },
      getHasKey: () => hasKey,

      setHasSword(value) {
        hasSword = value;
      },
      getHasSword: () => hasSword,

      setHasGivenSwordToNaoko(value) {
        hasGivenSwordToNaoko = value;
      },
      getHasGivenSwordToNaoko: () => hasGivenSwordToNaoko,

      setHasStrawberries(value) {
        hasStrawberries = value;
      },
      getHasStrawberries: () => hasStrawberries,

      setHasGivenStrawberriesToSatoshi(value) {
        hasGivenStrawberriesToSatoshi = value;
      },
      getHasGivenStrawberriesToSatoshi: () => hasGivenStrawberriesToSatoshi,

      setHasManga(value) {
        hasManga = value;
      },
      getHasManga: () => hasManga,

      setHasGivenMangaToMari(value) {
        hasGivenMangaToMari = value;
      },
      getHasGivenMangaToMari: () => hasGivenMangaToMari,

      setHasOriyoki(value) {
        hasOriyoki = value;
      },
      getHasOriyoki: () => hasOriyoki,

      setHasGivenOriyokiToKoji(value) {
        hasGivenOriyokiToKoji = value;
      },
      getHasGivenOriyokiToKoji: () => hasGivenOriyokiToKoji,

      // 🗝️ Persistent item flags
      setHasPickedUpAntiqueKey(value) {
        saveFlagToLocalStorage("hasPickedUpAntiqueKey", value);
      },
      getHasPickedUpAntiqueKey() {
        return loadFlagFromLocalStorage("hasPickedUpAntiqueKey");
      },

      setHasPickedUpManga(value) {
        saveFlagToLocalStorage("hasPickedUpManga", value);
      },
      getHasPickedUpManga() {
        return loadFlagFromLocalStorage("hasPickedUpManga");
      },

      setHasPickedUpOriyoki(value) {
        saveFlagToLocalStorage("hasPickedUpOriyoki", value);
      },
      getHasPickedUpOriyoki() {
        return loadFlagFromLocalStorage("hasPickedUpOriyoki");
      },

      setHasPickedUpSword(value) {
        saveFlagToLocalStorage("hasPickedUpSword", value);
      },
      getHasPickedUpSword() {
        return loadFlagFromLocalStorage("hasPickedUpSword");
      },

      setHasPickedUpStrawberries(value) {
        saveFlagToLocalStorage("hasPickedUpStrawberries", value);
      },
      getHasPickedUpStrawberries() {
        return loadFlagFromLocalStorage("hasPickedUpStrawberries");
      },
    };
  }

  return {
    getInstance() {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    },
  };
}